import {
  CheckCircle,
  Clock,
  AlertCircle,
  RefreshCcw,
  XCircle,
  RotateCcw,
} from "lucide-react";
import { cn } from "@/lib/utils";

interface PaymentStatusBadgeProps {
  status: string;
}

export function PaymentStatusBadge({ status }: PaymentStatusBadgeProps) {
  const baseClasses =
    "w-3.5 h-3.5 mr-1.5 inline-block transition-all duration-300";

  const statusConfig = {
    completed: {
      icon: (
        <CheckCircle
          className={cn(baseClasses, "text-green-500 dark:text-green-400")}
        />
      ),
      classes:
        "bg-green-50 text-green-700 dark:bg-green-950/30 dark:text-green-400 border-green-100 dark:border-green-900/50",
    },
    pending: {
      icon: (
        <Clock
          className={cn(baseClasses, "text-yellow-500 dark:text-yellow-400")}
        />
      ),
      classes:
        "bg-yellow-50 text-yellow-700 dark:bg-yellow-950/30 dark:text-yellow-400 border-yellow-100 dark:border-yellow-900/50",
    },
    processing: {
      icon: (
        <RefreshCcw
          className={cn(
            baseClasses,
            "text-blue-500 dark:text-blue-400 animate-spin"
          )}
        />
      ),
      classes:
        "bg-blue-50 text-blue-700 dark:bg-blue-950/30 dark:text-blue-400 border-blue-100 dark:border-blue-900/50",
    },
    refunded: {
      icon: (
        <RotateCcw
          className={cn(baseClasses, "text-purple-500 dark:text-purple-400")}
        />
      ),
      classes:
        "bg-purple-50 text-purple-700 dark:bg-purple-950/30 dark:text-purple-400 border-purple-100 dark:border-purple-900/50",
    },
    rejected: {
      icon: (
        <XCircle
          className={cn(baseClasses, "text-red-500 dark:text-red-400")}
        />
      ),
      classes:
        "bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400 border-red-100 dark:border-red-900/50",
    },
    failed: {
      icon: (
        <AlertCircle
          className={cn(baseClasses, "text-red-500 dark:text-red-400")}
        />
      ),
      classes:
        "bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400 border-red-100 dark:border-red-900/50",
    },
  };

  const config = statusConfig[status.toLowerCase()] || statusConfig.pending;

  return (
    <span
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border",
        config.classes
      )}
    >
      {config.icon}
      {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
    </span>
  );
}
